var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"button",staticClass:"c-screen-indicator online-indicator",class:{ 'status-online': _vm.haveScreen },attrs:{"data-url":_vm.url},on:{"click":_vm.openModal}},[_c('span',{staticClass:"online-indicator__status"}),_vm._v(" Presentatiescherm\n\t")])
}
var staticRenderFns = []

export { render, staticRenderFns }